import { render, staticRenderFns } from "./subscribes.vue?vue&type=template&id=2c9ca076&scoped=true&"
import script from "./subscribes.vue?vue&type=script&lang=js&"
export * from "./subscribes.vue?vue&type=script&lang=js&"
import style0 from "./subscribes.vue?vue&type=style&index=0&id=2c9ca076&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9ca076",
  null
  
)

export default component.exports